import { getBodyAdjusterImagesFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImages/getBodyAdjusterImagesQueryFunction';
import { GetBodyAdjusterImagesQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImages/getBodyDamagedAdjusterImagesQuery.type';
import { queryOptions } from '@tanstack/react-query';

export const getBodyAdjusterImagesQueryOptions = (
  params: GetBodyAdjusterImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getBodyAdjusterImagesQueryOptions', params],
    queryFn: () => getBodyAdjusterImagesFunction(params),
    enabled: !!params.enable,
    select: (data) => {
      const vehicle = data.vehicle.map((item) => ({
        id: item.id,
        url: item.image,
        label: item.title.fa_const,
        en_name: item.title.const,
      }));
      const damaged_parts = data.damaged_parts.map((item) => ({
        id: item.id,
        part_id: item.part_id,
        url: item.image,
        label: item.title.fa_const,
        en_name: item.title.const,
      }));
      return { vehicle, damaged_parts };
    },
  });
};
